import(/* webpackMode: "eager", webpackExports: ["PolicyPage"] */ "/app/components/legal/policy-page.tsx");
